var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 35.75C27.915 35.75 35.75 27.915 35.75 18.25C35.75 8.58502 27.915 0.75 18.25 0.75C8.58502 0.75 0.75 8.58502 0.75 18.25C0.75 27.915 8.58502 35.75 18.25 35.75Z",
    stroke: "#FF4A4A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3311 12.8238C29.05 11.603 28.0515 10.7023 26.8494 10.568C24.0028 10.2502 21.1217 10.2485 18.2538 10.2502C15.3854 10.2485 12.5038 10.2502 9.65718 10.568C8.45581 10.7023 7.45798 11.603 7.17695 12.8238C6.77696 14.5623 6.77246 16.4601 6.77246 18.2501C6.77246 20.0401 6.77246 21.9377 7.17245 23.676C7.453 24.8965 8.45107 25.7972 9.65315 25.9318C12.4995 26.2498 15.3809 26.2515 18.2493 26.2498C21.1181 26.2515 23.9988 26.2498 26.8449 25.9318C28.0463 25.7975 29.045 24.8968 29.3261 23.676C29.7263 21.9374 29.7277 20.0399 29.7277 18.2501C29.7277 16.4601 29.731 14.5623 29.3311 12.8238ZM15.2878 21.813C15.2878 19.2738 15.2878 16.7611 15.2878 14.2216C17.7206 15.491 20.1373 16.7518 22.5856 18.029C20.1449 19.2949 17.727 20.5481 15.2878 21.813Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.8da708ce446f549ab9d773c907b20b65.svg";
export { ForwardRef as ReactComponent };